<template>
  <div class="modal-top-section modal-top-section--align-center" v-if="!fromDetailTemplate">
    <div class="title-flex">
      <h3 class="modal-top-section__title">Asigna identificadores a tu IVR</h3>
      <a-tooltip
        :title="`Los identificadores son los diferentes números entrantes que posees en ${ProductName}.`"
      >
        <InfoCircleOutlined />
      </a-tooltip>
    </div>
    <p class="modal-top-section__subtitle">
      Asigna números entrantes a tu IVR. Puedes realizar esta acción luego.
    </p>
  </div>
  <a-form layout="vertical" :model="formState">
    <CustomScrollbar height="360px" style="padding-right: 10px">
      <IdentifiersSelector
        :channelType="ChannelType.VoiceInbound"
        v-model:values="formState.channels_customers"
        :disabled="disabled"
        :blocked-identifiers="blockedIdentifiers"
      />
    </CustomScrollbar>
  </a-form>
</template>

<script setup lang="ts">
import { reactive, watch } from "vue";
import { InfoCircleOutlined } from "@ant-design/icons-vue";
import { cloneDeep, isEqual } from "lodash";

import { IdentifiersForm } from "@/@types/ivr/forms";
import { Bot } from "@/@types/ivr";
import { ChannelType } from "@/app/shared/utils/enums";
import { ProductName } from "@/app/shared/utils/constants";

import IdentifiersSelector from "@/app/shared/components/selectors/IdentifiersSelector.vue";
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import { useAgentAIIdentifiers } from "@/app/shared/composables/useAgentAIIdentifiers";

const props = defineProps<{
  fromDetailTemplate?: boolean;
  botDetails?: Bot;
  disabled?: boolean;
}>();

const emit = defineEmits<{
  (e: "toggle-activate-button", isDisabled: boolean): void;
}>();

const formState = reactive<IdentifiersForm>({
  channels_customers: props.botDetails?.channels_customers?.map((channel) => channel.id) || [
    undefined,
  ],
});

const comparisonForm = cloneDeep(formState);

// Los identificadores de un Agente IA no se pueden usar en un IVR
const { blockedIdentifiers } = useAgentAIIdentifiers();

watch(formState, () => {
  const isDisabled = isEqual(formState, comparisonForm);

  emit("toggle-activate-button", isDisabled);
});

defineExpose({ formState });
</script>

<style scoped lang="sass">
h3
  color: $gray-9
  font-size: 20px
  margin-bottom: 16px

.title-flex
  display: flex
  justify-content: center
  gap: 10px
</style>
